import React from 'react'
import { useIntl } from 'react-intl'

import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Text,
  SpacingVertical,
  FormElement,
  InputText,
  Button,
  INPUT_TEXT_VARIANT_DANGER
} from 'mailup-web-components'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

import { regexEmail } from 'mailup-react-helpers'
import { modalOpportunityState } from './recoil/state/modal'
import { OpportunityConfirmCallback } from './recoil/callbacks/callbacks'

const ModalOpportunity = props => {
  const intl = useIntl()
  const setModalBrandShieldState = useSetRecoilState(modalOpportunityState)
  const { show, email, isEmailValid } = useRecoilValue(modalOpportunityState)
  const opportunityConfirm = useRecoilCallback(OpportunityConfirmCallback, [])
  const close = useResetRecoilState(modalOpportunityState)

  const handleEmailInputChange = ({ target: { value } }) => {
    setModalBrandShieldState(prev => ({
      ...prev,
      email: value,
      isEmailValid: value.match(regexEmail) !== null
    }))
  }

  return (
    <>
      <Modal show={show} onClose={close} size='S'>
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.DeliverabilityIndex.ModalTitle'
          })}
        />
        <ModalBody>
          <Text>
            {intl.formatMessage({
              id: 'Load.DeliverabilityIndex.ModalText'
            })}
          </Text>

          <SpacingVertical />
          <FormElement
            labelFor='email-contact'
            label={intl.formatMessage({
              id: 'Load.DeliverabilityIndex.ModalEmailLabel'
            })}
            required
            variant={!isEmailValid ? 'danger' : undefined}
            feedback={
              !isEmailValid
                ? intl.formatMessage({ id: 'Load.MailupCommon.EmptyEmail' })
                : undefined
            }
          >
            <InputText
              id='email-contact'
              onChange={handleEmailInputChange}
              value={email}
              variant={!isEmailValid ? INPUT_TEXT_VARIANT_DANGER : undefined}
            />
          </FormElement>
        </ModalBody>
        <ModalFoot>
          <Button
            onClick={close}
            kind='secondary'
            data-mu-test='Load.MailupCommon.Cancel'
          >
            {intl.formatMessage({
              id: 'Load.Common.Close'
            })}
          </Button>

          <Button
            onClick={opportunityConfirm}
            data-mu-test='brandShield-Contact'
            disabled={!isEmailValid || !email}
          >
            {intl.formatMessage({
              id: 'Load.MailupCommon.Send'
            })}
          </Button>
        </ModalFoot>
      </Modal>
    </>
  )
}

export default ModalOpportunity
